import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { ContactsCard } from "@/components/ContactsCard";
import { SpecialSituations } from "@/components/SpecialSituations";
import { Party, StaffRows } from "@/components/ContactPeople";
import { KycCard } from "@/components/KycCard";
import { gpTrata } from "@/components/gpView";
import { ProcessMessages } from "@/components/ProcessMessages";
import { Fold } from "@/components/Fold";

// Contactos rápidos começam fechados: quem precisa de um contacto abre-os e vai lá ter.
export function openContacts(sel, click = false) {
  window.dispatchEvent(new Event("open-contacts"));
  setTimeout(() => {
    const el = document.querySelector(sel) || document.getElementById("sec-contactos");
    el?.scrollIntoView({ behavior: "smooth", block: "center" });
    if (click && el) el.click();
  }, 80);
}


export function InboundAddress({ pid }) {
  const [addr, setAddr] = useState(null);
  useEffect(() => { api.get(`/processes/${pid}/inbound-address`).then(({ data }) => setAddr(data.address)).catch(() => {}); }, [pid]);
  if (!addr) return null;
  return (
    <div className="mx-6 mb-5 pt-4 border-t border-slate-100 flex items-center gap-3 text-sm text-slate-500" data-testid="process-inbound-address">
      <span className="flex-1 min-w-0">Reencaminhe para este endereço documentos que receba por email — entram neste processo: <span className="font-mono text-slate-700 break-all" data-testid="process-inbound-address-value">{addr}</span></span>
      <button onClick={() => { navigator.clipboard.writeText(addr).catch(() => {}); toast.success("Endereço copiado"); }} className="underline underline-offset-2 hover:text-slate-800 shrink-0" data-testid="process-inbound-copy">Copiar</button>
    </div>
  );
}

export function ProcessSidebar({ p, links, onDone, extra = null }) {
  const { user } = useAuth();
  const closed = ["escriturado", "sem_venda"].includes(p.status);
  const owners = (p.sellers || []).filter((s) => s.name);
  const contactsSub = owners.map((s) => s.name).join(" · ") || "Proprietário por indicar";
  const noPhone = owners.some((s) => !s.phone);
  const [force, setForce] = useState(window.location.hash === "#sec-contactos" ? 1 : 0);
  useEffect(() => {
    const f = () => setForce((n) => n + 1);
    window.addEventListener("open-contacts", f);
    return () => { window.removeEventListener("open-contacts", f); };
  }, []);
  return (
    <div className="space-y-4" data-testid="process-sidebar">
      <div id="sec-contactos" className="scroll-mt-24">
        <Fold title="Contactos rápidos" sub={`${contactsSub}${noPhone ? " · falta telemóvel" : ""}`} testid="contacts-section" defaultOpen={false} open={force}>
          <div className="px-[18px] md:px-6">
            <Party role="vendedor" links={links} p={p} onDone={onDone} />
            <Party role="comprador" links={links} p={p} onDone={onDone} />
            <StaffRows p={p} onDone={onDone} />
            <ContactsCard p={p} onDone={onDone} embedded ro={user?.role === "direccao" || closed} />
          </div>
        </Fold>
      </div>
      {extra}
      <ProcessMessages p={p} onDone={onDone} />
      {!gpTrata(p) && <KycCard pid={p.id} version={p.updated_at} />}
      {!gpTrata(p) && <SpecialSituations p={p} onDone={onDone} readOnly={user?.role === "direccao" || closed} />}
    </div>
  );
}
